// extracted by mini-css-extract-plugin
export var actions = "_11-0";
export var actionsContainer = "_11-7";
export var border = "_11-1";
export var childFullHeight = "_11-f";
export var collapse = "_11-2";
export var content = "_11-a";
export var contentChild = "_11-e";
export var fullscreen = "_11-c";
export var hasLeftRadius = "_11-k";
export var headerContainer = "_11-3";
export var headerRow = "_11-5";
export var hidePadding = "_11-b";
export var navCollapsedGap = "_11-l";
export var noScrollX = "_11-m";
export var noScrollY = "_11-n";
export var noTopPadding = "_11-i";
export var optOutTopPadding = "_11-d";
export var pageMain = "_11-j";
export var pageOuter = "_11-g";
export var pagePadding = "_11-8";
export var pageScroll = "_11-9";
export var profile = "_11-o";
export var profileContainer = "_11-p";
export var profileImage = "_11-q";
export var profileMain = "_11-r";
export var profileSubtitle = "_11-t";
export var profileTitle = "_11-s";
export var showLeftPadding = "_11-h";
export var tabsPortalSlot = "_11-6";
export var tabsWrapper = "_11-4";
export var title = "_11-u";